<input #avatarFilePicker
  type="file"
  accept="image/jpeg,image/png,image/gif"
  id="avatar_file_input"
  name="avatar_file_input"
  class="sr-only"
  [attr.aria-label]="text.label_choose_avatar"
  [attr.disabled]="busy || undefined"
  (change)="onFilePickerChanged($event)" />
<div class="avatars--error-pane">
  @if (fileInvalid) {
    <span [textContent]="text.wrong_file_format"></span>
  }
</div>
